<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.construction.material_management.isometric_request.title')" header-tag="h3" class="bg-default-card">
                    <b-tabs>
                        <b-tab :title="$t('general.construction.material_management.isometric_request.current_material_title')" @click="refreshCurrentRequests" class="removeFocus">
                            <isometricCurrentMaterialRequests ref="isometricCurrentMaterialRequests"></isometricCurrentMaterialRequests>
                        </b-tab>

                        <b-tab :title="$t('general.construction.material_management.isometric_request.archived_material_title')" @click="refreshArchivedRequests" class="removeFocus">
                            <isometricArchivedMaterialRequests ref="isometricArchivedMaterialRequests"></isometricArchivedMaterialRequests>
                        </b-tab>
                    </b-tabs>
                </b-card>

                <div class="row">
                    <div class="col-sm-12">
                        <i class="fa fa-2x fa-arrow-circle-up blue--text text-default"></i> - {{$t('general.buttons.pickup')}} &nbsp;&nbsp;
                        <i class="fa fa-2x fa-file-pdf-o text-default"></i> - {{$t('general.buttons.download_material')}} &nbsp;&nbsp;
                        <i class="fa fa-2x fa-file-pdf-o text-primary"></i> - {{$t('general.buttons.download_pickup')}} &nbsp;&nbsp;
                        <i class="fas fa-2x fa-user-friends text-dark m-1 sortable"></i> - {{$t('general.buttons.show_teams')}} &nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import isometricCurrentMaterialRequests from '@/components/pages/project/construction/material_management/isometric_material_requests/isometric_current_material_requests';
import isometricArchivedMaterialRequests from '@/components/pages/project/construction/material_management/isometric_material_requests/isometric_archived_material_requests';

export default {
name: 'isometric_material_requests',
components: {
    isometricCurrentMaterialRequests,
    isometricArchivedMaterialRequests
},
data () {
    return {
            currentTab: 0,
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.construction.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.construction.material_management.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.construction.material_management.isometric_request.title'),
                    active: true
                }
            ]
        }
    },
    methods: {
        refreshCurrentRequests () {
            if (this.currentTab == 1) {
                this.$refs.isometricCurrentMaterialRequests.loadTable();
            }
            this.currentTab = 0;
        },
        refreshArchivedRequests () {
            if (this.currentTab == 0) {
                this.$refs.isometricArchivedMaterialRequests.loadTable();
            }
            this.currentTab = 1;
        }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/pages/project/construction/material_management/isometric_material_requests/isometric_material_requests.vue